import React from 'react'
import Logo from './Logo'
import Menu from './Menu'
import { faAddressBook, faAddressCard, faCalculator, faFileInvoice, faGlobe, faHeadphones, faMobile, faVectorSquare } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';


const Header = () => {
  const navigate = useNavigate();
  const menuItems = [
    { label: 'Who we help', path: '/' , subMenu: [
      { label: 'Staffing and Recruitment Firms', path: '/staffing-and-recruitment-firms',icon:faCalculator },
      { label: 'Companies Hiring Internationally', path: '/companies-hiring-internationally',icon:faGlobe },
      { label: 'Contractors', path: '/contractors',icon:faHeadphones },
    ],},
    { label: 'Where we help', path: '/countries' },
    { label: 'Why Ampstek Pay',subMenu: [
      { label: 'Careers', path: '/careers',icon:faHeadphones },
      { label: 'Our Experts', path: '/meet-the-experts',icon:faAddressCard },
      { label: 'Our Platform', path: '/workforce-management-technology',icon:faVectorSquare }
    ], },
   
/*     { label: 'Resources',subMenu: [
      { label: 'Blogs', path: '/resources/blog',icon:faAddressBook },
      { label: 'Ebooks', path: '/resources/case-studies',icon:faMobile },
      { label: 'Case Studies', path: '/resources/whitepapers',icon:faFileInvoice },
    ], }, */
    { label: 'Payroll', path: '/payroll' },
    { label: 'Contact us', path: '/contact-us' },
  ];

  const handleLoginClick = () => {
    navigate("/");
  };
  const handleExpertClick = () => {
    navigate("/meet-the-experts");
  };
  return (
    <>
    <div className="header-section">
        <div className="container">
            <div className="header-data">
                <Logo />
                <Menu menuItems={menuItems} onLoginClick={handleLoginClick} onSpeakClick={handleExpertClick}/>
            </div>
        </div>
    </div>
    </>
  )
}

export default Header